import Modal from "../components/modal";
import react from 'react';

export default class RoverExtendedOptionsModal extends react.Component {
  constructor(props) {
    super(props);

    this.state = { 
      show: props.show,
      hideAction: props.hideAction
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside() {
    this?.state?.hideAction && this?.state.hideAction();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ show: nextProps.show });  
  }

  render() {
    return (
      <>
        <Modal show = {this.state.show} header = {"Rover - extended options"} hideAction = {this.state.hideAction}>
            <div className="mb-6">
              <h3 className="h4-font-size subheading">Position of axis of rotation</h3>
              <p>You can set the distance from rear point of your rover for your axis of rotation.</p>
              <img src="../rover-axisOfRotation.png" alt="Position of axis of rotation" className="d-block mx-auto object-fit-cover rounded" />
            </div>
            <div className="mb-6">
              <h3 className="h4-font-size subheading">Position of GNSS receiver</h3>
              <p>You can set the distance from rear point of your rover for your axis of rotation.</p>
              <img src="../rover-gpsReceiver.png" alt="Position of GNSS receiver" className="d-block mx-auto object-fit-cover rounded" />
            </div>
        </Modal>
      </>
    );
  }
};